import React from 'react';
import { useTran } from '@/hooks/useTran';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef(({ className, inputClassName, label, placeholder, error, ...props }, ref) => {
	const { t } = useTran();

	return (
		<div className={cn('space-y-1', className)}>
			{label ? <label className="block font-medium text-foreground">{t(label)}</label> : null}
			<textarea
				ref={ref}
				data-slot="textarea"
				placeholder={t(placeholder)}
				className={cn(
					'flex min-h-[80px] w-full rounded-md border-input border bg-background text-foreground px-3 py-2 transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50',
					inputClassName,
				)}
				{...props}
			/>
			{error ? <small className="text-destructive text-xs">{error}</small> : null}
		</div>
	);
});

Textarea.displayName = 'Textarea';

export { Textarea };
